import React from "react";
import ArApOffsetsGenericSkeleton from "./ArApOffsetsGenericSkeleton";

function ArApOffsetsDetailSkeleton() {
  return (
    <>
      <ArApOffsetsGenericSkeleton />
    </>
  );
}

export default ArApOffsetsDetailSkeleton;
